<template>
  <div class="container-fluid mt-2">
    <h2>Aktions Codes</h2>
    <div role="toolbar" class="btn-toolbar justify-content-between">
      <div class="btn-group">
        <button class="btn btn-secondary" @click="prevPage()" id="prev"><font-awesome-icon icon="chevron-left"/></button>
        <button class="btn btn-secondary" @click="nextPage()" id="next"><font-awesome-icon icon="chevron-right"/></button>
      </div>
      <div class="input-group">
        <div class="input-group-prepend">
          <button class="btn btn-secondary"><font-awesome-icon icon="search"/></button>
        </div>
        <input class="form-control" @keyup="fetchData()" id="search" v-model="search" type="text"/>
      </div>
      <div class="input-group">
        <select @change="fetchData" v-model="status" class="form-control">
          <option value="-1">Alle</option>
          <option value="0">Neu</option>
          <option value="1">Aktiv</option>
          <option value="2">Abgebrochen</option>
          <option value="3">Beendet</option>
        </select>
      </div>
      <div class="btn-group">
        <button @click="createAction" class="btn btn-primary">Neue Aktion</button>
      </div>
    </div>
    <b-table @row-clicked="openAction" class="mt-3" striped hover :fields="fields" :items="rows">
      <template #cell(allCustomer)="data">
        <font-awesome-icon v-if="data.item.allCustomer" icon="check"/>
      </template>
      <template v-slot:cell(start)="data">
        {{ data.item.start.substring(0,10) }}
      </template>
      <template v-slot:cell(end)="data">
        {{ data.item.end.substring(0,10) }}
      </template>
      <template v-slot:cell(status)="data">
        <div v-if="data.item.status == 0">
          NEU
        </div>
        <div v-else-if="data.item.status == 1">
          AKTIV
        </div>
        <div v-else-if="data.item.status == 2">
          ABGEBROCHEN
        </div>
        <div v-else-if="data.item.status == 3">
          BEENDET
        </div>
      </template>
      <template v-slot:cell(action)="data">
        <button @click="deleteGiftcard(data.item)" class="btn btn-danger">
          <font-awesome-icon icon="trash"/>          
        </button>
      </template>
    </b-table>
  </div>
</template>

<script>
import giftcards from '@/modules/giftcards.js'
import router from '@/router'

export default {
  name: 'GiftCardList',
  data() {
    return {
      start: 0,
      count: 40,
      search: '',
      status: -1,
      rows: [],
      fields: [
        {key: 'title', label: 'Name'},
        {key: 'code', label:'Code'},
        {key: 'start', label: 'Start'},
        {key: 'end', label: 'Ende'},
        {key: 'contact', label: 'Kontakt'},
        {key: 'allCustomer',label:'Alle Kunden'},
        {key: 'status', label: 'Status'},
        {key: 'action', label: 'Aktion'}
      ]
    }
  },
  created: function() {
    this.fetchData();
  },
  methods: {
    prevPage() {
      if (this.start > 0) {
        this.start -= this.count;
        this.fetchData();
      }
    },
    nextPage() {
      this.start += this.count;
      this.fetchData();
    },
    fetchData() {
      var self = this;
      giftcards.list(this,this.start,this.count,'%' + this.search + '%',this.status,function(data) {
        if (data) {
          self.rows = data;
        }
      })
    },
    deleteGiftcard(item) {
      console.log('delete giftcard: ',item.map_id);
      if (confirm('Möchten Sie den Code "' +item.code + '" wirklich löschen?')) {
        console.log('delete: ',item.map_id,giftcards);
        giftcards.delete(item.map_id);
      }
    },
    openAction(item) {
      router.push({name: 'GiftCardEditor',params: {id: item.map_id}});
    },
    createAction() {
      router.push({ name:'GiftCardEditor',params: {id: 'new'}});
    }
  }
}
</script>
